var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurveySuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 0.5C12.32 0.5 0 12.82 0 28C0 43.18 12.32 55.5 27.5 55.5C42.68 55.5 55 43.18 55 28C55 12.82 42.68 0.5 27.5 0.5ZM22 41.75L8.25 28L12.1275 24.1225L22 33.9675L42.8725 13.095L46.75 17L22 41.75Z",
    fill: "#2CBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveySuccess);
export default __webpack_public_path__ + "static/media/surveySuccess.193e32a77788d4eadc443db8164658ea.svg";
export { ForwardRef as ReactComponent };